import React, { useContext, useEffect } from 'react'
import { Button, Text, View } from 'oio-react'
import WarningIcon from 'assets/icons/warning'
import { ThemeUtilsContext } from 'src/libraries/contexts/Theme'

const NotFound = () => {
   const themeUtilsContext = useContext(ThemeUtilsContext)

   // We want to try and hide the global nav. However, this component
   // may be rendered in the context of the ErrorBoundary, in which case
   // there is no ThemeProvider component. So we check if the context exists
   // before attempting to override the theme props.
   useEffect(() => {
      if (themeUtilsContext) {
         const { setThemePropsForComponent, removeThemePropsForComponent } = themeUtilsContext
         setThemePropsForComponent('NotFound')
         return () => {
            removeThemePropsForComponent('NotFound')
         }
      }
   }, [])

   return (
      <View
         width="100%"
         height="100vh"
         display="flex"
         justifyContent="center"
         alignItems="center"
         backgroundColor="#181818"
         textAlign="center">
         <View
            display="flex"
            flexFlow="column"
            justifyContent="center"
            alignItems="center"
            padding="30px"
            maxWidth="100%[a-b] 450px[c-f]">
            <WarningIcon
               color="#444"
               width="90px"
               height="90px"
               strokeWidth="1px"
            />
            <View float="left" width="100%" height="18px" />
            <Text size="3[a-b] 4[c-f]" color="#aaa" lineHeight="150%" weight="medium">
               Sorry! The page you are looking for
               <br />
                could not be found.
            </Text>
            <View float="left" width="100%" height="12px" />
            <Text size="2" color="#666" lineHeight="150%">
               Please check that the link is correct.
               Otherwise, the page might have been moved, renamed, deleted, or may require
               you to be logged in to see it.
            </Text>
            <View float="left" width="100%" height="30px" />
            <a href="/">
               <Button
                  name="Return Home"
                  color="#444"
                  size="sm"
                  rounded
               />
            </a>
         </View>
      </View>
   )
}

export default React.memo(NotFound)
